/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FileDownloadResponse } from '../../models/file-download-response';

export interface GetSecurityFile$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
  langCode: 'FR' | 'EN' | 'DE' | 'ES' | 'IT' | 'PL';

/**
 * The type of energy:
 *   * ELECTRICITY
 *   * WATER
 *   * HYDROGEN
 *   * GNL
 *   * GNC
 *   * GNCL
 *   * BIOGNC
 *   * UNDEFINED
 */
  energyType: 'ELECTRICITY' | 'WATER' | 'HYDROGEN' | 'GNL' | 'GNC' | 'GNCL' | 'BIOGNC' | 'UNDEFINED';
}

export function getSecurityFile(http: HttpClient, rootUrl: string, params: GetSecurityFile$Params, context?: HttpContext): Observable<StrictHttpResponse<FileDownloadResponse>> {
  const rb = new RequestBuilder(rootUrl, getSecurityFile.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('langCode', params.langCode, {});
    rb.query('energyType', params.energyType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FileDownloadResponse>;
    })
  );
}

getSecurityFile.PATH = '/custom/station/{uid}/SecurityFile';
